import { render, staticRenderFns } from "./AppDev.vue?vue&type=template&id=bdf0678a&"
import script from "./AppDev.vue?vue&type=script&lang=js&"
export * from "./AppDev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports